// extracted by mini-css-extract-plugin
module.exports = {"tabGroup":"tabs_tabGroup__3-PRu","tab":"tabs_tab__HDUEl","active":"tabs_active__1llyG","trapezoid":"tabs_trapezoid__f9ewJ","content":"tabs_content__22i6S"};